import { render, staticRenderFns } from "./div-img.vue?vue&type=template&id=f2751898&scoped=true"
import script from "./div-img.vue?vue&type=script&lang=js"
export * from "./div-img.vue?vue&type=script&lang=js"
import style0 from "./div-img.vue?vue&type=style&index=0&id=f2751898&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2751898",
  null
  
)

export default component.exports